import { BroadcastChannel } from "broadcast-channel";

export const logoutChannel = new BroadcastChannel("logout");